/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo Dominios.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/dominios',
    name: 'dominios.index',
    component: () => import('./views/DominiosIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'dominios.read',
      title: 'Dominios',
    },
  },
]

export default routes
